export const STATUS = [
  { v: "assegnato", l: "Assegnato" },
  { v: "preso_in_carico", l: "Preso in carico" },
  { v: "in_lavorazione", l: "In lavorazione" },
  { v: "completato", l: "Completato" },
  { v: "sospeso", l: "Sospeso" },
  { v: "sospeso_manutenzione", l: "Sospeso e inviato a Manutenzione" },
  { v: "da_sbloccare", l: "Da Sbloccare" },
  { v: "ko", l: "KO" },
];
export const STATUS_LABEL = Object.fromEntries(STATUS.map((s) => [s.v, s.l]));

export const STATUS_STYLE = {
  assegnato: "bg-blue-50 text-blue-700 border-blue-200",
  preso_in_carico: "bg-indigo-50 text-indigo-700 border-indigo-200",
  in_lavorazione: "bg-amber-50 text-amber-700 border-amber-200",
  completato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sospeso: "bg-red-50 text-red-700 border-red-200",
  ko: "bg-red-100 text-red-900 border-red-300",
};
export const STATUS_BAR = {
  assegnato: "bg-blue-500",
  preso_in_carico: "bg-indigo-500",
  in_lavorazione: "bg-amber-500",
  completato: "bg-emerald-500",
  sospeso: "bg-red-500",
  ko: "bg-red-900",
};
export const STATUS_HEX = {
  assegnato: "#3b82f6",
  preso_in_carico: "#6366f1",
  in_lavorazione: "#f59e0b",
  completato: "#10b981",
  sospeso: "#ef4444",
  sospeso_manutenzione: "#9333ea",
  da_sbloccare: "#f97316",
  ko: "#7f1d1d",
};

export const PRIORITY = [
  { v: "bassa", l: "Bassa" },
  { v: "media", l: "Media" },
  { v: "alta", l: "Alta" },
  { v: "urgente", l: "Urgente" },
];
export const PRIORITY_LABEL = Object.fromEntries(PRIORITY.map((p) => [p.v, p.l]));

export const PRIORITY_STYLE = {
  bassa: "bg-slate-100 text-slate-600 border-slate-200",
  media: "bg-blue-50 text-blue-700 border-blue-200",
  alta: "bg-amber-50 text-amber-700 border-amber-200",
  urgente: "bg-red-50 text-red-700 border-red-200",
};
export const PRIORITY_BAR = {
  bassa: "bg-slate-400",
  media: "bg-blue-500",
  alta: "bg-amber-500",
  urgente: "bg-red-500",
};

export const CAT_COLOR = {
  Installazione: "#1D4ED8",
  Manutenzione: "#D97706",
  "Riparazione guasto": "#DC2626",
  Sopralluogo: "#059669",
};

export const ROLE_LABEL = {
  admin: "Admin",
  responsabile: "Responsabile",
  tecnico: "Tecnico",
};

export const PICCO_OPTIONS = ["Visibile", "Non Visibile", "Non Caratterizzato"];
